import { render, staticRenderFns } from "./IdeaStatus.vue?vue&type=template&id=5b6738c9&scoped=true&"
import script from "./IdeaStatus.vue?vue&type=script&lang=js&"
export * from "./IdeaStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6738c9",
  null
  
)

export default component.exports